"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasCreatedAtAndUpdatedAtJsDate = exports.typeguardArrayFunctionLogWrapper = exports.typeguardFunctionLogWrapper = exports.typeguardErrorWrapper = exports.typeguardFunctionWrapper = void 0;
const jsonschema_1 = __importDefault(require("jsonschema"));
const Log_1 = require("../types/Log");
const typeguardFunctionWrapper = (schema) => (obj, onErrors) => {
    const { valid, errors } = jsonschema_1.default.validate(obj, schema, {
        nestedErrors: true,
    });
    if (errors.length > 0 && onErrors) {
        onErrors(errors);
    }
    return valid;
};
exports.typeguardFunctionWrapper = typeguardFunctionWrapper;
const _manageTypeguardLogError = (params) => {
    const { typeguardName, logInputs, errors } = params;
    const { logLevel, logger, metadata } = logInputs ?? {};
    if (logger) {
        const errorMessages = errors.map(({ stack }) => stack).join(', ');
        const errObj = {
            message: `"${typeguardName}" typeguard incurred ${errors.length} errors: ${errorMessages}`,
            metadata: { logMeta: { ...metadata } },
        };
        logger(errObj, logLevel || Log_1.LogLevel.Error);
    }
};
/**
 * This util just returns back the associated typeguard errors
 */
const typeguardErrorWrapper = (params) => (obj) => {
    const { schema } = params;
    const { errors } = jsonschema_1.default.validate(obj, schema, {
        nestedErrors: true,
    });
    return errors.map((err) => err.stack);
};
exports.typeguardErrorWrapper = typeguardErrorWrapper;
const typeguardFunctionLogWrapper = (params) => (obj, logInputs) => {
    const { schema, typeguardName } = params;
    return (0, exports.typeguardFunctionWrapper)(schema)(obj, (errors) => {
        _manageTypeguardLogError({ logInputs, errors, typeguardName });
    });
};
exports.typeguardFunctionLogWrapper = typeguardFunctionLogWrapper;
const typeguardArrayFunctionLogWrapper = (params) => (obj, logInputs) => {
    const { schema, typeguardName } = params;
    if (!Array.isArray(obj)) {
        if (logInputs?.logger) {
            const errObj = {
                message: `"${typeguardName}" typeguard expected array input`,
            };
            logInputs.logger(errObj, logInputs.logLevel || Log_1.LogLevel.Error);
        }
        return false;
    }
    let isValid = true;
    const errors = [];
    for (const item of obj) {
        const jsonResult = jsonschema_1.default.validate(item, schema, {
            nestedErrors: true,
        });
        jsonResult.errors.forEach((err) => errors.push(err));
        isValid = isValid && jsonResult.valid;
    }
    if (errors.length > 0) {
        _manageTypeguardLogError({ logInputs, errors, typeguardName });
        return false;
    }
    return isValid;
};
exports.typeguardArrayFunctionLogWrapper = typeguardArrayFunctionLogWrapper;
// jsonschema types JsDate object as string, with date-time annotation,
// we need a translation layer when typeguarding types containing JsDate
const hasCreatedAtAndUpdatedAtJsDate = ({ obj, typeName, logInputs, }) => {
    const { logLevel, logger, metadata } = logInputs ?? {};
    if (typeof obj !== 'object') {
        if (logger) {
            logger({
                message: `Expected ${typeName} to be typeof object, but got [type:${typeof obj}]`,
                metadata: { logMeta: metadata },
            }, logLevel ?? Log_1.LogLevel.Error);
        }
        return false;
    }
    if (!('created_at' in obj && obj.created_at instanceof Date) ||
        !('updated_at' in obj && obj.updated_at instanceof Date)) {
        if (logger) {
            logger({
                message: `Expected ${typeName} to have properties created_at and updated_at of type JsDate object.`,
                metadata: { logMeta: metadata },
            }, logLevel ?? Log_1.LogLevel.Error);
        }
        return false;
    }
    return true;
};
exports.hasCreatedAtAndUpdatedAtJsDate = hasCreatedAtAndUpdatedAtJsDate;
//# sourceMappingURL=typeguardUtils.js.map